import { faCopy, faEye, faFileImport, faPenToSquare, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axiosInstance from '../config/axiosInstance'
import MonetizationView from "./View";
import MonetizationImport from "./Import";
import { Toast } from "react-bootstrap";
import PaginationBar from '../components/common/PaginationBar';

function MonetizationList() {
  const [monetizationList, setMonetizationList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedMonetization, setSelectedMonetization] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleView = (monetization) => {
    setSelectedMonetization(monetization);
    setShowModal(true);
  };

  const handleImport = (monetization) => {
    setSelectedMonetization(monetization);
    setShowImportModal(true);
  };

  const onSaveSuccessfully = () => {
    getMonetizationList().then(() => setShowToast(true));
  };

  useEffect(() => {
    getMonetizationList().then(r => {});
  }, []);

  let getMonetizationList = async () => {
    try {
      const res = await axiosInstance.get("/monetization/get");
      setMonetizationList(res.data?.data?.items ?? []);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  let handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm("Are you sure do you want to delete the data?");
      if (confirmDelete) {
        await axiosInstance.post(`/monetization/delete`, {
          id: id
        });
        await getMonetizationList();
      }
    } catch (error) {
      console.log(error);
    }
  }

  let handleDuplicate = async (id) => {
    try {
      const confirmDelete = window.confirm("Are you sure do you want to duplicate the data?");
      if (confirmDelete) {
        await axiosInstance.post(`/monetization/duplicate`, {
          id: id
        });
        await getMonetizationList();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const filteredList = monetizationList.filter(monetization =>
    (filterText === "" || (monetization?.description && monetization.description.toLowerCase().includes(filterText.toLowerCase())))
  );

// Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
      <>
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide style={{ position: 'fixed', top: 20, right: 20, backgroundColor: '#28a745', color: 'white' }}>
          <Toast.Body>Import successful!</Toast.Body>
        </Toast>
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Monetization List</h1>
          <div className="align-items-end">
            <Link to="/portal/create-monetization" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
              <FontAwesomeIcon icon={faPlus} className="creating-monetization mr-2" />
              Create Monetization
            </Link>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="mb-3 col-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Name"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>

            {
              isLoading ? <img src='https://media.giphy.com/media/ZO9b1ntYVJmjZlsWlm/giphy.gif' alt="Loading" />
                  : <div className="table-responsive">
                    <nav>
                      <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredList.length} onPageChange={paginate} />
                    </nav>
                    <table className="table table-bordered monetization-table" id="dataTable" width="100%" cellSpacing="0">
                      <thead>
                      <tr>
                        <th>Id</th>
                        <th>Version</th>
                        <th>Platform</th>
                        <th>Environment</th>
                        <th>Description</th>
                        <th>Threshold (ms)</th>
                        <th>App Events</th>
                        <th>Screen Events</th>
                        <th>Domain</th>
                        <th>Is Latest</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tfoot>
                      <tr>
                        <th>Id</th>
                        <th>Version</th>
                        <th>Platform</th>
                        <th>Environment</th>
                        <th>Description</th>
                        <th>Threshold (ms)</th>
                        <th>App Events</th>
                        <th>Screen Events</th>
                        <th>Domain</th>
                        <th>Is Latest</th>
                        <th>Action</th>
                      </tr>
                      </tfoot>
                      <tbody>
                      {currentItems.map((monetization) => {
                        return (
                            <tr key={monetization.id}>
                              <td>{monetization.id}</td>
                              <td>{monetization?.version}</td>
                              <td>{monetization?.platform}</td>
                              <td>{monetization?.environment}</td>
                              <td className="monetization-description">{monetization?.description}</td>
                              <td>{monetization?.content?.event_threshold_in_milliseconds}</td>
                              <td>{monetization?.content?.app_events?.length ?? 0}</td>
                              <td>{monetization?.content?.screen_events?.length ?? 0}</td>
                              <td><div className="monetization-domain text-truncate" title={monetization?.domain}>{monetization?.domain}</div></td>
                              <td>{monetization?.is_latest ? "Yes" : "No"}</td>
                              <th className="text-nowrap">
                                {/* Icon-only on desktop so the 11 columns fit; labels return on the mobile cards */}
                                <button onClick={() => handleView(monetization)} className="btn btn-success btn-sm mr-1" title="View" aria-label="View"><FontAwesomeIcon icon={faEye} /><span className="d-md-none ms-1">View</span></button>
                                <Link to={`/portal/monetization-edit/${monetization.id}`} className='btn btn-outline-primary btn-sm mr-1' title="Edit" aria-label="Edit"><FontAwesomeIcon icon={faPenToSquare} /><span className="d-md-none ms-1">Edit</span></Link>
                                <button onClick={() => handleDuplicate(monetization.id)} className='btn btn-warning btn-sm mr-1' title="Duplicate" aria-label="Duplicate"><FontAwesomeIcon icon={faCopy} /><span className="d-md-none ms-1">Duplicate</span></button>
                                <button onClick={() => handleImport(monetization)} className="btn btn-success btn-sm mr-1" title="Import" aria-label="Import"><FontAwesomeIcon icon={faFileImport} /><span className="d-md-none ms-1">Import</span></button>
                                <button onClick={() => handleDelete(monetization.id)} className='btn btn-danger btn-sm mr-1' title="Delete" aria-label="Delete"><FontAwesomeIcon icon={faTrash} /><span className="d-md-none ms-1">Delete</span></button>
                              </th>
                            </tr>
                        )
                      })}
                      </tbody>
                    </table>
                    <nav>
                      <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredList.length} onPageChange={paginate} />
                    </nav>
                  </div>
            }
          </div>
          {showModal && (
            <MonetizationView show={showModal} onClose={() => setShowModal(false)} monetization={selectedMonetization} />
          )}

          {showImportModal && (
            <MonetizationImport show={showImportModal} onClose={() => setShowImportModal(false)} monetization={selectedMonetization}
              onSaveSuccessfully={onSaveSuccessfully}
            />
          )}
        </div>
      </>
  )
}

export default MonetizationList
